import { z } from "zod";

import { fillTemplate } from "../values/fill-template";
import copyJson from "./order-policy-copy.json";

const text = z.string().min(1);

const copySchema = z.object({
  amendment: z.object({
    directionChange: text,
    quantityBelowMoved: text,
    movementWord: z.object({ purchase: text, sale: text }),
  }),
  relation: z.object({ companyUnavailable: text, requestedByUnavailable: text, customerRequestorMismatch: text, shipToSaleOnly: text }),
  movement: z.object({
    warehouseChargesPurchaseOnly: text,
    requiresPlacedOrder: text,
    futureDate: text,
    fulfilledPastOrderNote: text,
    invalidDate: text,
  }),
  deliverySchedule: z.object({ notScheduled: text, totalFinite: text, via: text, batch: text, shipTo: text, addressNumber: text }),
  lifecycle: z.object({
    defaultLabels: z.object({ submittedAt: text, orderedAt: text, arrivedDate: text }),
    expectedDeliveryLabel: text,
    required: text,
    requiresLaterStatus: text,
    future: text,
    precedes: text,
  }),
  unknownDocumentType: text,
});

const copy = copySchema.parse(copyJson);

export const ORDER_AMENDMENT_COPY = copy.amendment;
export const ORDER_RELATION_COPY = copy.relation;
export const ORDER_MOVEMENT_COPY = copy.movement;
export const ORDER_DELIVERY_SCHEDULE_COPY = copy.deliverySchedule;
export const LIFECYCLE_DEFAULT_DATE_LABELS = copy.lifecycle.defaultLabels;
export const EXPECTED_DELIVERY_LABEL = copy.lifecycle.expectedDeliveryLabel;

export function quantityBelowMovedMessage(moved: string, movement: string): string {
  return fillTemplate(copy.amendment.quantityBelowMoved, { moved, movement });
}

export function lifecycleRequiredMessage(label: string): string {
  return fillTemplate(copy.lifecycle.required, { label });
}

export function lifecycleRequiresLaterStatusMessage(label: string): string {
  return fillTemplate(copy.lifecycle.requiresLaterStatus, { label });
}

export function lifecycleFutureMessage(label: string): string {
  return fillTemplate(copy.lifecycle.future, { label });
}

export function lifecyclePrecedesMessage(later: string, earlier: string): string {
  return fillTemplate(copy.lifecycle.precedes, { later, earlier });
}

export function unknownOrderDocumentTypeMessage(documentType: string): string {
  return fillTemplate(copy.unknownDocumentType, { documentType });
}
